import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn'
import CodeIcon from '@mui/icons-material/Code'
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline'
import DeviceHubIcon from '@mui/icons-material/DeviceHub'
import AccessTimeIcon from '@mui/icons-material/AccessTime'
import PeopleIcon from '@mui/icons-material/People'
import Wrapper from 'components/Wrapper/Wrapper'
import ProductsCard from './ProductsCard'
import './Products.scss'

const productsCardItems = [
	{
		icon: <AssignmentTurnedInIcon sx={{ fontSize: '2rem' }} />,
		title: 'Requirements Gathering',
		subtitle:
			'I work closely with clients to understand their project requirements and goals to ensure the final product meets their expectations.',
	},
	{
		icon: <CodeIcon sx={{ fontSize: '2rem' }} />,
		title: 'Coding',
		subtitle:
			'With a strong foundation in HTML, CSS, and JavaScript, I am able to develop high-quality, dynamic, and interactive web applications.',
	},
	{
		icon: <CheckCircleOutlineIcon sx={{ fontSize: '2rem' }} />,
		title: 'Quality Assurance',
		subtitle:
			'I take pride in delivering bug-free and polished code. I thoroughly test my work to ensure that it meets the highest standards.',
	},
	{
		icon: <DeviceHubIcon sx={{ fontSize: '2rem' }} />,
		title: 'Cross-browser Compatibility',
		subtitle:
			'I ensure that all of my projects are compatible with the latest web browsers to ensure optimal performance for users.',
	},
	{
		icon: <AccessTimeIcon sx={{ fontSize: '2rem' }} />,
		title: 'Time Management',
		subtitle: 'I am able to manage my time effectively to meet deadlines and ensure the timely delivery of projects.',
	},
	{
		icon: <PeopleIcon sx={{ fontSize: '2rem' }} />,
		title: 'Collaboration',
		subtitle:
			'I am a strong collaborator and enjoy working with clients, designers, and other developers to bring projects to life.',
	},
]

const Products = () => {
	return (
		<Wrapper className='products' id='products'>
			<div className='products__container-title'>
				<h3 className='products__title'>How I work?</h3>
			</div>
			{productsCardItems.map(({ icon, title, subtitle }) => (
				<ProductsCard key={title} icon={icon} title={title} subtitle={subtitle} />
			))}
		</Wrapper>
	)
}

export default Products
